<template>
    <router-link
            class="card-footer-item"
            :to="route" 
          >
    <div class="tile is-parent">
      <div
        class="card tile is-child"
        :style="{ backgroundColor: color, maxWidth: '22.5rem'}"
      >
        <div class="card-content">
          <div class="level is-mobile">
            <div class="level-item">
              <div class="is-widget-label">
                <h3 class="subtitle is-spaced has-text-light"><span style="color: white; font-weight: bold; ">{{ title }}</span> <span style="font-style: italic;">{{ secondTitle }}</span></h3>
                <h1 class="title">
                  <div style="color: #fff;">{{ value }}</div>
                </h1>
              </div>
            </div>
            <div class="level-item has-widget-icon">
              <div class="is-widget-icon">
                <span class="icon has-text-light is-large">
                  <i :class="`mdi ${icon} mdi-48px`"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </router-link>
  </template>
  
  <script>
  export default {
    name: 'CardWidget',
    props: {
      title: {
        type: String,
        required: true,
      },
      secondTitle: {
        type: String,
        required: false,
      },
      route: {
        type: String,
        required: true,
      },
      value: {
        type: Number | undefined,
        required: true,
      },
      icon: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: '', 
      },
    },
  }
  </script>
  
  <style scoped>
  
  </style>
  